var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"list-item-icon"},[_c('iconic',{attrs:{"name":_vm.icon}})],1),_c('div',{staticClass:"list-item-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }